import {ConfirmDeactivateGuard} from 'src/app/core/guards/confirm-deactivate.guard';
import {UserGroupComponent} from './user-group/user-group.component';
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from './main/main.component';
import {EnterpriseComponent} from './enterprise/enterprise.component';
import {TranslateModule} from '@ngx-translate/core';
import {CustomerComponent} from './customer/customer/customer.component';
import {AddCustomerComponent} from './customer/customer/add-customer/add-customer.component';
import {SynchronizeCustomerComponent} from './customer/customer/synchronize-customer/synchronize-customer.component';
import {UpdateCustomerComponent} from './customer/customer/update-customer/update-customer.component';
import {BranchComponent} from './branch/branch.component';
import {UserComponent} from './user/user.component';
import {AuthGuard} from 'src/app/core/auth/auth.guard';
import {PermissionConfig} from 'src/app/core/constants/permission-config';
import {ViewCustomerComponent} from './customer/customer/view-customer/view-customer.component';
import {AddBranchComponent} from './branch/add-branch/add-branch.component';
import {UpdateBranchComponent} from './branch/update-branch/update-branch.component';
import {CanActivateChildGuard} from 'src/app/core/guards/can-activate-child.guard';
import {DocumentTypeComponent} from './document-type/document-type.component';
import {AddDocumentTypeListComponent} from './document-type/add-document-type-list/add-document-type-list.component';
import {AddDocumentComponent} from './document/add-document/add-document.component';
import {DocumentGroupManageComponent} from './document/document-group-manage/document-group-manage.component';
import {SynchronizeDocumentGroupComponent} from './document/document-group-manage/synchronize-document-group/synchronize-document-group.component';
import {SearchDocumentComponent} from './document/search-document/search-document.component';
import {SearchDocumentSignComponent} from './document/search-document-sign/search-document-sign.component';
import {SearchDocumentReceiveComponent} from './document/search-document-receive/search-document-receive.component';
import {ViewDocumentComponent} from './document/view-document/view-document.component';
import {DigitalCertificateComponent} from './digital-certificate/digital-certificate.component';
import {NotifyComponent} from './notify/notify.component';
import {CertificatePolicyComponent} from './digital-certificate/certificate-policy/certificate-policy.component';
import {AnalysisReportComponent} from '../home-enterprise/analysis-report/analysis-report.component';
import {SearchDocumentMineComponent} from './document/search-document-mine/search-document-mine.component';
import {SearchDocumentSignApproveComponent} from './document/search-document-sign-approve/search-document-sign-approve.component';
import {SearchDocumentSignInitialComponent} from './document/search-document-sign-initial/search-document-sign-initial.component';
import {SearchWaitingConfirmDocumentComponent} from './document/search-waiting-confirm-document/search-waiting-confirm-document.component';
import {SetupSignFlowReceiveComponent} from './document/setup-sign-flow-receive/setup-sign-flow-receive.component';
import {SignFlowDocumentComponent} from './document/sign-flow-document/sign-flow-document.component';
import {DEFAULT_FULL_PERMISSION_LIST, FeatureGroup} from 'src/app/core/constants/permission';
import {TotalContractReportComponent} from './report/total-contract-report/total-contract-report.component';
import {SmsQuantityReportComponent} from './report/sms-quantity-report/sms-quantity-report.component';
import {SmsMoneyReportComponent} from './report/sms-money-report/sms-money-report.component';
import {ContractEnterpriseCreateComponent} from './report/contract-enterprise-create/contract-enterprise-create.component';
import {ContractPersonalCreateComponent} from './report/contract-personal-create/contract-personal-create.component';
import {ContractEnterpriseReceiveComponent} from './report/contract-enterprise-receive/contract-enterprise-receive.component';
import {DocumentManagementComponent} from './document-management/document-management.component';
import { GeneralCategoryComponent } from './general-category/general-category.component';
import { DigitalCertificateDefaultComponent } from './digital-certificate-default/components/digital-certificate-default.component';
import {SearchDocumentMineReceiveComponent} from './document/search-document-mine-receive/search-document-mine-receive.component';
import { AddLotComponent } from './contract-lot/add-lot/add-lot.component';
import { ProcedureManagementComponent } from './procedure-management/procedure-management.component';
import { UserProcedureManagementComponent } from './user-config/user-procedure-management/user-procedure-management.component';
import { DepartmentComponent } from './department/components/department.component';
import {ContractDigitizationComponent} from './document/contract-digitization/contract-digitization.component';
import {ConfigGeneralManageComponent} from './document/document-group-manage/config-general-manage/config-general-manage.component';
import {AddDocumentGroupV2Component} from './document/document-group-manage/add-document-group-v2/add-document-group-v2.component';
import { MultipleSignFlowViewComponent } from './document/search-document-mine/multiple-sign-flow-view/multiple-sign-flow-view.component';
import { CertificateMoneyReportComponent } from './report/certificate-money-report/certificate-money-report.component';
import { TimestampQuantityReportComponent } from './report/timestamp-quantity-report/timestamp-quantity-report.component';
import { SignBatchResultComponent } from './document/sign-document/sign-batch-result/sign-batch-result.component';
import { ViewDetailBranchComponent } from './branch/view-detail-branch/view-detail-branch.component';
import { AddUserGroupComponent } from './user-group/add-user-group/add-user-group.component';
import { AuthoUserGroupComponent } from './user-group/autho-user-group/autho-user-group.component';
import { GroupCustomerComponent } from './group-customer/group-customer.component';
import { CreateGroupCustomerComponent } from './group-customer/create-group-customer/create-group-customer.component';
import { ExportDataCustomerComponent } from './customer/customer/export-data-customer/export-data-customer.component';
import {EnterpriseConfigComponent} from './enterprise-config/enterprise-config.component';
import { SignConfirmDocumentComponent } from './document/sign-confirm-document/sign-confirm-document.component';
import {ContractDigitizationBusinessComponent} from './document/contract-digitization-by-business/contract-digitization-business.component';
import { ApproveBatchResultComponent } from './document/sign-document/approve-batch-result/approve-batch-result.component';
import { DeclineApprovalBatchResultComponent } from './document/sign-document/decline-approval-batch-result/decline-approval-batch-result.component';
import {ContractUserReportComponent} from "./report/contract-user-report/contract-user-report.component";
import { SignFlowDocumentV2Component } from './document/sign-flow-document-v2/sign-flow-document-v2.component';
import { EnterpriseNotificationComponent } from './enterprise-notification/enterprise-notification.component';
import { LinkGoogleAccountComponent } from './link-google-account/link-google-account.component';
import { AddDocumentQuicklyComponent } from './document/add-document-quickly/add-document-quickly.component';
import { EnterpriseActionLogComponent } from './enterprise-action-log/enterprise-action-log.component';
import { SearchDocumentProcessingComponent } from './document/search-document-processing/search-document-processing.component';
import { SearchNegotiateDocumentComponent } from './document/search-negotiate-document/search-negotiate-document.component';
import { SearchDocumentSharePartner } from './document/search-document-share-partner/search-document-share-partner.component';
import { ContractProcessingReportComponent } from './report/contract-processing-report/contract-processing-report.component';
import { SignFlowDigitalDocumentComponent } from './document/sign-flow-digital-document/sign-flow-digital-document.component';
import {LinkAccountComponent} from './link-account/link-account.component';
import { SignDigitalBatchResultComponent } from './document/sign-document/sign-digital-batch-result/sign-digital-batch-result.component';
import { LaborUtilizationReportComponent } from './labor-utilization-report/labor-utilization-report.component';
import { AddLaborUtilizationReportComponent } from './labor-utilization-report/add-labor-utilization-report/add-labor-utilization-report.component';
import { AddDocumentMohaComponent } from './document/add-document-moha/add-document-moha.component';
import { ViewDocumentMohaComponent } from './document/view-document-moha/view-document-moha.component';
import { AddLotMohaComponent } from './contract-lot-moha/add-lot-moha/add-lot-moha.component';
import { ContractDigitizationMohaComponent} from '../home-enterprise/contract-digitzation-moha/contract-digitzation-moha.component';
import { MenuExportReportComponent } from './menu-export-report/menu-export-report.component';
import { SearchDocumentContractCompanyComponent} from './document/search-document-contract-company/search-document-contract-company.component';
import { ShareResourceComponent } from './digital-certificate/share-resource/share-resource.component';
import {SmsHistoryReportComponent} from "./report/sms-history-report/sms-history-report.component";
import { ApprovedContractMohaComponent} from './document/approved-contract-moha/approved-contract-moha.component';
import { DocumentApprovedContractComponent} from './document/document-approved-contract/document-approved-contract.component';
import { SignFlowDocumentApproveComponent } from './document/sign-flow-document-approve/sign-flow-document-approve.component';
import { ViewDocumentMohaApproveComponent } from './document/view-document-moha-approve/view-document-moha-approve.component';
import {SearchDocumentSignApproveDigitalComponent} from './document/search-document-sign-approve-digital/search-document-sign-approve-digital.component';
import { ViewDocumentMohaDigitalComponent } from './document/view-document-moha-digital/view-document-moha-digital.component';
import {SearchDocumentSignDigitalComponent} from './document/search-document-sign-digital/search-document-sign-digital.component';
import { SignFlowDocumentDigitalComponent } from './document/sign-flow-document-digital/sign-flow-document-digital.component';

import { SignDocumentMohaReportComponent } from './document/sign-document-moha-report/sign-document-moha-report.component';
import { StandardLaborContractComponent} from './document/standardizing-labor-contracts/standardizing-labor-contracts.component';
import { LaborContractStandardizeSearchComponent } from './document/labor-contract-standardize-search/labor-contract-standardize-search.component';
import { LaborContractStandardizeEmployeeComponent } from './document/labor-contract-standardize-employee/labor-contract-standardize-employee.component';
import { ContractLotStandardizedComponent } from './contract-lot-standardized/contract-lot-standardized/contract-lot-standardized.component';

const routes: Routes = [
  {
    path: 'default',
    component: DigitalCertificateDefaultComponent
  },
  {path: '', redirectTo: 'analysis-report', pathMatch: 'full'},
  {
    path: 'analysis-report',
    component: AnalysisReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: [0],
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  // {
  //   path: 'main',
  //   component: MainComponent,
  //   canActivate: [
  //     AuthGuard,
  //     CanActivateChildGuard
  //   ],
  //   data: {
  //     accessRight: [
  //       {
  //         userType: 1,
  //         permissons: DEFAULT_FULL_PERMISSION_LIST,
  //         checkParent: false
  //       },
  //       {
  //         userType: 2,
  //         permissons: DEFAULT_FULL_PERMISSION_LIST,
  //         checkParent: false
  //       },
  //       {
  //         userType: 3,
  //         permissons: DEFAULT_FULL_PERMISSION_LIST,
  //         checkParent: false
  //       },
  //       {
  //         userType: 4,
  //         permissons: DEFAULT_FULL_PERMISSION_LIST,
  //         checkParent: false
  //       },
  //       {
  //         userType: 5,
  //         permissons: DEFAULT_FULL_PERMISSION_LIST,
  //         checkParent: false
  //       },
  //     ],
  //     defaultPath: 'home-enterprise'
  //   }
  // },
  {
    path: 'digital-certificate',
    component: DigitalCertificateComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/digital-certificate/digital-certificate.module').then(m => m.DigitalCertificateModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.digital_certificate'],
      id: PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
  path: 'enterprise-action-log',
    component: EnterpriseActionLogComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/enterprise-action-log/enterprise-action-log.module').then(m => m.EnterpriseActionLogModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_action_log'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
  path: 'department',
    component: DepartmentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/department/department.module').then(m => m.DepartmentModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.department'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'enterprise',
    component: EnterpriseComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/enterprise/enterprise.module').then(m => m.EnterpriseModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_info', 'breadcrumbs.enterprise_info'],
      id: PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'customers',
    component: CustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/customer/customer.module').then(m => m.CustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.management_customer', 'breadcrumbs.enterprise_customer'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [401, 402, 403, 406, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-customer',
    component: AddCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [401, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'update-customer/:id',
    component: UpdateCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [401, 403, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-customer/:id',
    component: ViewCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [401, 402, 403, 406, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'group-customers',
    component: GroupCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/group-customer/group-customer.module').then(m => m.GroupCustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.management_customer', 'breadcrumbs.enterprise_group_customer'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [404, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'create-group-customers',
    component: CreateGroupCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/group-customer/group-customer.module').then(m => m.GroupCustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.management_customer', 'breadcrumbs.enterprise_create_group_customer'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [404, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'manage-group-customers/:id',
    component: CreateGroupCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('../home-enterprise/group-customer/group-customer.module').then(m => m.GroupCustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.management_customer', 'breadcrumbs.enterprise_manage_group_customer'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [404, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'export-data-customer',
    component: ExportDataCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.management_customer', 'title.export_data_customer'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [405, 4],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },

  {
    path: 'synchronize-customer',
    component: SynchronizeCustomerComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'branches',
    component: BranchComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.branch'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-detail-branch/:id',
    component: ViewDetailBranchComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    data: {
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-branch',
    component: AddBranchComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    data: {
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'update-branch/:id',
    component: UpdateBranchComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    data: {
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-document',
    component: AddDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_create'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'new-document-moha',
    component: AddDocumentMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'title.contract_moha'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-contract-quickly',
    component: AddDocumentQuicklyComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_create_quickly'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },

  {
    path: 'search-document',
    component: SearchDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.document_breadcrumbs', 'breadcrumbs.enterprise_create_doccument'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'document-group-manage',
    component: DocumentGroupManageComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.service_types'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },

  {
    path: 'synchronize-document-group',
    component: SynchronizeDocumentGroupComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.service_types'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-document-sign',
    component: SearchDocumentSignComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_search_sign'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'digital-search-document',
    component: SearchDocumentSignDigitalComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.document_search_sign_digital'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-approval-waiting-document',
    component: SearchDocumentSignApproveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.enterprise_waiting_approve_doc'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-approval-waiting-document-digital',
    component: SearchDocumentSignApproveDigitalComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.document_search_approve_digital'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-my-created-document',
    component: SearchDocumentMineComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.my_created_document'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-multiple-sign-flow',
    component: MultipleSignFlowViewComponent,

    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.my_created_document'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-batch-result',
    component: SignBatchResultComponent,

    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_search_sign', 'breadcrumbs.sign_batch_info'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'approve-batch-result',
    component: ApproveBatchResultComponent,

    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_search_approve', 'breadcrumbs.approve_batch_info'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'decline-approval-batch-result',
    component: DeclineApprovalBatchResultComponent,

    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_search_decline_approval', 'breadcrumbs.decline_approve_batch_info'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-my-receive-document',
    component: SearchDocumentMineReceiveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.my_receive_document'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-document-receive',
    component: SearchDocumentReceiveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.document_breadcrumbs', 'breadcrumbs.document_search_receive'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.RECEIVE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'digital-contract',
    component: ContractDigitizationComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/contract-digitization/contract-digitization.module').then(m => m.ContractDigitizationModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_digitization'],
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-digital-flow/:id',
    component: SignFlowDigitalDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/contract-digitization/contract-digitization.module').then(m => m.ContractDigitizationModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_digitization'],
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'digital-business',
    component: ContractDigitizationBusinessComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/contract-digitization-by-business/contract-digitization-business.module').then(m => m.ContractDigitizationBusinessModule),
    data: {
      breadcrumb: ['breadcrumbs.document_breadcrumbs', 'breadcrumbs.document_digitization_business'],
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-initial-waiting-document',
    component: SearchDocumentSignInitialComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.enterprise_waiting_initial_doc'],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-waiting-confirm-document',
    component: SearchWaitingConfirmDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.enterprise_waiting_confirm_doc'],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'user',
    component: UserComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_user'],
      id: PermissionConfig.EN_ADMIN_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        }
        // ,
        // {
        //   userType: 3,
        //   permissons: DEFAULT_FULL_PERMISSION_LIST,
        //   checkParent: false
        // }
        ,
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'user-group',
    component: UserGroupComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./user-group/user-group.module').then(m => m.UserGroupModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_groupuser'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        }
        ,
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-user-group',
    component: AddUserGroupComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./user-group/user-group.module').then(m => m.UserGroupModule),
    data: {
      // breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_add_group_user'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        }
        ,
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'autho-user-group/:id',
    component: AuthoUserGroupComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./user-group/user-group.module').then(m => m.UserGroupModule),
    data: {
      // breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_groupuser'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        }
        ,
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'document-type',
    component: DocumentTypeComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document-type/document-type.module').then(m => m.DocumentTypeModule),
    data: {
      breadcrumb: ['breadcrumbs.enterprise_info', 'breadcrumbs.document_type'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [3, 1],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-document/:id',
    component: ViewDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-document-moha/:id',
    component: ViewDocumentMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
         checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-document-moha-digital/:id',
    component: ViewDocumentMohaDigitalComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
         checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-document-moha-approve/:id',
    component: ViewDocumentMohaApproveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
         checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-confirm-document/:id',
    component: SignConfirmDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-document/:id',
    component: SignFlowDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-document-moha-report/:id',
    component: SignDocumentMohaReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-document-v2/:id',
    component: SignFlowDocumentV2Component,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-document-digital/:id',
    component: SignFlowDocumentDigitalComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-document-approve/:id',
    component: SignFlowDocumentApproveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'setup-sign-flow-receive/:id',
    component: SetupSignFlowReceiveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'update-document/:id',
    component: AddDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'update-document-moha/:id',
    component: AddDocumentMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'notify',
    component: NotifyComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./notify/notify.module').then(m => m.NotifyModule),
    runGuardsAndResolvers: 'always',
    data: {
      breadcrumb: ['breadcrumbs.notify_list'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  // {
  //   path: 'digital-certificate',
  //   component: DigitalCertificateComponent,
  //   canActivate: [
  //     AuthGuard,
  //     CanActivateChildGuard
  //   ],
  //   loadChildren: () => import('./digital-certificate/digital-certificate.module').then(m => m.DigitalCertificateModule),
  //   data: { id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE }
  // },
  {
    path: 'certificate-policy',
    component: CertificatePolicyComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'total-contract-report',
    component: TotalContractReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_contract_report'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sms-quantity-report',
    component: SmsQuantityReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_sms'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sms-money-report',
    component: SmsMoneyReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_money_sms'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-enterprise-create',
    component: ContractEnterpriseCreateComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_contract_company'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-personal-create',
    component: ContractPersonalCreateComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_contract_individual'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-enterprise-receive',
    component: ContractEnterpriseReceiveComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.total_contract_take'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.RECEIVE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'certificate-money-report',
    component: CertificateMoneyReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.certificate_money_report'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-user-report',
    component: ContractUserReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.number_of_contract_user'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'timestamp-quantity-report',
    component: TimestampQuantityReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.timestamp_quantity_report'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'document-template',
    component: DocumentManagementComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('././document-management/document-management.module').then(m => m.DocumentManagementModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.document'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [3, 1],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'general-category',
    component: GeneralCategoryComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('././general-category/general-category.module').then(m => m.GeneralCategoryModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.general'],
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [3, 1],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-lot',
    component: AddLotComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-lot/contract-lot.module').then(m => m.ContractLotModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.create_contract_lot'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-lot-moha',
    component: AddLotMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-lot-moha/contract-lot-moha.module').then(m => m.ContractLotMohaModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      breadcrumb: ['breadcrumbs.my_contracts', 'title.create_contract_lot_moha'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-digital-add-lot',
    //component: UploadFileDigitalComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-digital-add-lot/contract-digital-add-lot.module').then(m => m.ContractDigitalAddLotModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sms-history-report',
    component: SmsHistoryReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.sms_history_report'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sms-history-report/analysis-report',
    component: AnalysisReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      breadcrumb: ['menu_report.env_report', 'menu_report.sms_history_report', 'menu_report.analysis_report'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'procedure-management',
    component: ProcedureManagementComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    // loadChildren: () => import('../home-enterprise/customer/customer.module').then(m => m.CustomerModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.procedure_management_enterprise'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'usr-procedure-management',
    component: UserProcedureManagementComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      breadcrumb: ['breadcrumbs.user-config', 'breadcrumbs.procedure_management_user'],
      id: PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-lot/:id',
    component: AddLotComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-lot/contract-lot.module').then(m => m.ContractLotModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.view_contract_lot'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-lot-moha/:id',
    component: AddLotMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-lot-moha/contract-lot-moha.module').then(m => m.ContractLotMohaModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      breadcrumb: ['breadcrumbs.my_contracts', 'title.view_lot_moha'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
   {
    path: 'contract-lot-standardized/:id',
    component: ContractLotStandardizedComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./contract-lot-standardized/contract-lot-standardized.module').then(m => m.ContractLotStandardizedModule),
    data: {
      id: PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE,
      breadcrumb: ['breadcrumbs.my_documents', 'title.view_lot_standardized_moha'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'config-general-manage',
    component: ConfigGeneralManageComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.service_types'],
      id: PermissionConfig.EN_ADMIN_DOCUMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-document-group-v2',
    component: AddDocumentGroupV2Component,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.service_types'],
      id: PermissionConfig.EN_ADMIN_DOCUMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'enterprise-config',
    component: EnterpriseConfigComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./enterprise-config/enterprise-config.module').then(m => m.EnterpriseConfigModule),
    data: {
      breadcrumb: [ 'breadcrumbs.general_config', 'breadcrumbs.enterprise_config'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'enterprise-notification',
    component: EnterpriseNotificationComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./enterprise-notification/enterprise-notification.module').then(m => m.EnterpriseNotificationModule),
    data: {
      breadcrumb: [ 'breadcrumbs.general_config', 'breadcrumbs.enterprise_notification'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'connect-account',
    component: LinkAccountComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./link-account/link-account.module').then(m => m.LinkAccountModule),
    data: {
      breadcrumb: [ 'breadcrumbs.user-config', 'breadcrumbs.link_account'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-processing-document',
    component: SearchDocumentProcessingComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_processing'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-negotiate-document',
    component: SearchNegotiateDocumentComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: [ 'breadcrumbs.my_documents', 'negotiate_contract.breadcrumb'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-document-share-partner',
    component: SearchDocumentSharePartner,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: [ 'breadcrumbs.document_breadcrumbs', 'contract_share_partner.breadcrumb'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [13,1301],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-processing',
    component: ContractProcessingReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: {
      breadcrumb: ['menu_report.env_report', 'breadcrumbs.document_processing'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'sign-digital-batch-result',
    component: SignDigitalBatchResultComponent,

    data: {
      breadcrumb: ['breadcrumbs.my_documents', 'breadcrumbs.document_digitization'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'share-resource',
    component: ShareResourceComponent,

    data: {
      breadcrumb: ['breadcrumbs.general_config', 'breadcrumbs.resource_transfer'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'search-document-contract-company',
    component: SearchDocumentContractCompanyComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.document_breadcrumbs', 'breadcrumbs.contract-company'],
      id: PermissionConfig.EN_ADMIN_BRANCH_MANAGE,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ] ,
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'labor-utilization-report',
    component: LaborUtilizationReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./labor-utilization-report/labor-utilization-report.module').then(m => m.LaborUtilizationReportModule),
    data: {
      breadcrumb: [ 'breadcrumbs.general_config', 'breadcrumbs.labor_usage_report_configuration'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight:[
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'labor-utilization-report/create',
    component: AddLaborUtilizationReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./labor-utilization-report/add-labor-utilization-report/add-labor-utilization-report.module').then(m => m.AddLaborUtilizationReportModule),
    data: {
      breadcrumb: [ 'breadcrumbs.general_config', 'breadcrumbs.labor_usage_report_configuration'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'labor-utilization-report/update/:id',
    component: AddLaborUtilizationReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./labor-utilization-report/add-labor-utilization-report/add-labor-utilization-report.module').then(m => m.AddLaborUtilizationReportModule),
    data: {
      breadcrumb: [ 'breadcrumbs.general_config', 'breadcrumbs.labor_usage_report_configuration'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'menu-export-report',
    component: MenuExportReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./menu-export-report/menu-export-report.module').then(m => m.MenuExportReportModule),
    data: {
      breadcrumb: [ 'menu_report.env_report', 'title.menu_export_report'],
      id: PermissionConfig.EN_ADMIN_DEPARTMENT,
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'contract-digitzation-moha',
    component: ContractDigitizationMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./contract-digitzation-moha/contract-digitzation-moha.module').then(m => m.ContractDigitizationMohaModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.document_moha'],
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'approved-contract-moha',
    component: ApprovedContractMohaComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.approved_contract_moha'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'document-approved-contract',
    component: DocumentApprovedContractComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.my_document_moha'],
      accessRight: [
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'standardizing-labor-contracts',
    component: StandardLaborContractComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'breadcrumbs.standardzing_contract'],
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT],
          checkParent: false
        }
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-conditions-standard-employment',
    component: LaborContractStandardizeSearchComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'left_menu.add_conditions_employment'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'add-conditions-standard-employees',
    component: LaborContractStandardizeEmployeeComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    canDeactivate: [ConfirmDeactivateGuard],
    loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
    data: {
      breadcrumb: ['breadcrumbs.my_contracts', 'left_menu.add_conditions_employment'],
      accessRight: [
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class HomeEnterpriseRoutingModule { }
